<template>

    <tr>
        <td class="track-data px-0">
            <p class="mb-0 small">
                {{ track.title }}
                <br />
                Track No. {{ track.track_number }}
            </p>
        </td>
        <td class="track-data px-0">
            <p class="mb-0 small">
                {{ track.composer }}
                <br />
                <span v-if="track.album">
                    {{ track.album.name }}
                </span>
                    <span v-if="!track.album">
                    No Album
                </span>
            </p>
        </td>
        <td class="px-0">
            <div class="form-group form-control-sm mb-0 track-duration-container">
                <input v-model="trackDuration" v-on:keyup="onTrackDurationRawChange" :ref="'refTrackDuration_' + track.id" class="form-control duration-input duration-input--raw" placeholder="00:00" />
                <input v-model="trackDurationParsed" v-on:focus="onTrackDurationParsedFocus" :ref="'refTrackDurationParsed_' + track.id" class="form-control duration-input duration-input--parsed" placeholder="00:00" />
            </div>
        </td>
        <td class="px-0">
            <div class="form-group form-control-sm mb-0">
                <input v-model.lazy="trackNotes" class="form-control" placeholder="Track Notes"/>
            </div>
        </td>
    </tr>

</template>

<script>

    import Vue from 'vue';

    export default Vue.component(
        'email-cue-sheet-row',
        {

            data: function () {

                return {

                    trackDuration: null,
                    trackDurationParsed: null,
                    trackNotes: null,

                };

            },

            props: {
                track: {
                    type: Object,
                    default: null,
                },
                trackDurationProp: {
                    type: String|Number,
                    default: null,
                },
                trackDurationParsedProp: {
                    type: String,
                    default: null,
                },
                trackNotesProp: {
                    type: String,
                    default: null,
                },
            },

            created() {

                this.trackDuration = this.trackDurationProp;
                this.trackDurationParsed = this.trackDurationParsedProp;
                this.trackNotes = this.trackNotesProp;

            },

            methods: {

                onTrackDurationParsedFocus: function(ev) {

                    // Focus on the raw sibling field.
                    if( typeof this.$refs['refTrackDuration_' + this.track.id] !== 'undefined' ) {
                        $(this.$refs['refTrackDuration_' + this.track.id]).focus();
                    }

                },

                onTrackDurationRawChange: function() {

                    var ctx = this;

                    if(RegExp('^[0-9]*$').test( this.trackDuration )){

                        ctx.trackDurationParsed = ctx.parseDuration( ctx.trackDuration );

                    } else {

                        ctx.trackDurationParsed = ctx.trackDuration.replace(new RegExp('[^0-9]+'), '');

                    }

                },

                reset: function () {

                    this.trackDuration = null;
                    this.trackDurationParsed = null;
                    this.trackNotes = null;

                },

                parseDuration: function( rawDuration ) {

                    rawDuration = parseInt(rawDuration, 10).toString();

                    if( isNaN( rawDuration ) ) {
                        return;
                    }

                    let len = rawDuration.length;

                    var parsedDuration = null;

                    if(len == 2){
                        parsedDuration = rawDuration.substring(0, len-2) + "00:" + rawDuration.substring(len-2);
                    }
                    if(len == 1){
                        parsedDuration = rawDuration.substring(0, len-2) + "00:0" + rawDuration.substring(len-2);
                    }
                    if(len == 3){
                        parsedDuration = '0'+ rawDuration.substring(0, len-2) + ":" + rawDuration.substring(len-2);
                    }
                    if(len > 3){
                        parsedDuration = rawDuration.substring(0, len-2) + ":" + rawDuration.substring(len-2);
                    }

                    return parsedDuration;

                }

            },

            watch: {

                track: function (value) {
                    this.reset();
                },

                trackDuration: function(value) {
                    this.$emit('trackDuration', value);
                },

                trackDurationParsed: function(value) {
                    this.$emit('trackDurationParsed', value);
                },

                trackNotes: function(value) {
                    this.$emit('trackNotes', value);
                }

            }

        }
    );

</script>

<style>
    .duration-input.duration-input--raw {
        height: 0;
        overflow: hidden;
        width: 0;
        margin: 0;
        padding: 0;
        border: none;
    }

    .duration-input.duration-input--raw:focus + .duration-input--parsed {
        border-color: #9acffa;
    }

</style>
